import * as React from "react";
function SvgAgExams(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 10.208h5v-4h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5v11h8v-5h-1v-2zm1.126 9H5a2 2 0 01-2-2v-13h4v-2h2v2h4v-2h2v2h4v6h3v2h-1v6a4 4 0 01-7.874 1zm5.874-7h-4v3h4v-3z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgAgExams);
export default ForwardRef;
